import { useMutation, useQueryClient } from '@tanstack/react-query';
import { http } from '.';
import { AxiosRequestConfig } from 'axios';

interface UploadProgressParams {
  progress: number;
}

interface MutationAuthenticationOption {
  onUploadProgress?: (params: UploadProgressParams) => void;
  method?: 'post' | 'put' | 'patch' | 'delete';
}

interface MutateOptions {
  url: string;
  cacheKeys?: string[];
}

export const mutateConfig =
  ({ onUploadProgress, method = 'post' }: MutationAuthenticationOption = {}) =>
  <T>(options: MutateOptions) => {
    const queryClient = useQueryClient();
    const { url, cacheKeys } = options;

    const handlePost = async (
      body: unknown
    ): Promise<{ status: number; payload: T; }> => {
      const { status, data } = await http[method](
        url,
        body as AxiosRequestConfig<unknown> | undefined,
        {
          onUploadProgress: (params) =>
            onUploadProgress &&
            onUploadProgress(params as UploadProgressParams),
        }
      );

      return { status, payload: data };
    };

    return useMutation({
      mutationFn: async (
        body: unknown
      ): Promise<{ status: number; payload: T }> => {
        const { status, payload } = await handlePost(body);
        return { status, payload };
      },
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: cacheKeys });
      },
    });
  };
